import Header from "../components/Header";
import React from "react";
import Profil from "../components/profile/Profil";
import Footer from "../components/Footer";

const Home = () => {
    return (
        <div>
             <Header />
                <Profil />
            <Footer/>
        </div>

    );
}

export default Home;